import { useState } from "react";
import { de } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fmtDate, parseISO, toISO } from "./calendarUtils";

// German date picker: shows TT.MM.JJJJ, value/onChange use YYYY-MM-DD
export function DateField({ value, onChange, testId, className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className={`h-10 w-full px-3 flex items-center justify-between bg-[#0A0A0A] border border-white/20 text-white text-sm rounded-md ${className}`} data-testid={testId}>
          <span className={value ? "" : "text-[#71717A]"}>{value ? fmtDate(value) : "TT.MM.JJJJ"}</span>
          <CalendarDays className="w-4 h-4 text-[#71717A]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-[#121212] border-white/10 text-white" align="start">
        <Calendar mode="single" locale={de} weekStartsOn={1} selected={value ? parseISO(value) : undefined}
          defaultMonth={value ? parseISO(value) : undefined}
          onSelect={(d) => { if (d) { onChange(toISO(d)); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}

const TIMES = Array.from({ length: 49 }, (_, i) => `${String(Math.floor(i / 2)).padStart(2, "0")}:${i % 2 ? "30" : "00"}`);

// 24h time select in 30-minute steps
export function TimeSelect({ value, onChange, testId, from = 0, to = 48, className = "" }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={`h-8 px-1 bg-transparent text-white text-sm ${className}`} data-testid={testId}>
      {!TIMES.slice(from, to + 1).includes(value) && <option value={value}>{value || "–"}</option>}
      {TIMES.slice(from, to + 1).map((t) => <option key={t} value={t} className="bg-[#121212]">{t}</option>)}
    </select>
  );
}
